import { useCallback, useMemo, useState } from "react";

import { parseDataUrl, fetchWithRetry } from "../utils/services.utils";

const useRegisterNewsletter = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const url = useMemo(() => {
    return `https://${process.env.REACT_APP_API}/user/newsletter_register/`;
  }, []);

  const registerNewsletter = useCallback(
    (params, options = null) => {
      setData(null);
      setError(null);
      setLoading(true);

      const fetchOptions = {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: parseDataUrl(params),
        signal: options?.signal,
      };

      fetchWithRetry(url, fetchOptions)
        .then((response) => {
          setError(response.error || null);
          delete response.error;
          setData(response);
        })
        .catch((error) => {
          setData(null);
          setError(error);
          setLoading(false);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [url]
  );

  const clear = useCallback(() => {
    setData(null);
    setError(null);
    setLoading(false);
  }, []);

  return { loading, data, error, registerNewsletter, clear };
};

export default useRegisterNewsletter;
